import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { routerActions, RouterState } from '@ngrx/router-store';

export interface RouterHistoryState {
  connected: boolean;
  history: RouterState[];
}

export const ROUTER_HISTORY_INITIAL_STATE: RouterHistoryState = {
  connected: false,
  history: []
}

const ACTION_STRINGS = [
  routerActions.BACK,
  routerActions.FORWARD,
  routerActions.GO,
  routerActions.REPLACE,
  routerActions.SEARCH,
  routerActions.SHOW,
  routerActions.UPDATE_LOCATION
];

export function routerHistoryReducer(state: RouterHistoryState = ROUTER_HISTORY_INITIAL_STATE, {type, payload}): RouterHistoryState {

  switch (type) {
    case routerActions.UPDATE_LOCATION:
      let p = Object.assign({}, payload);
      p.path = (!!p.path) ? p.path.split('?')[0] : p.path;
      return Object.assign({}, state, { history: [p, ...state.history], connected: true });
  }

  return state;

}

@Injectable()
export class RouterHistoryService {

  public pathHistory: Observable<string[]>;

  constructor(
    private _store: Store<{
      routerHistory: RouterHistoryState
    }>
  ) {

    this.pathHistory = this._store.select(s => s.routerHistory)
      .map(s => s.history.map(s => s.path));

  }

}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/services/router-history.service.ts